import React, { useEffect, useState } from 'react';
import { withRouter } from 'next/router';
import PropTypes from 'prop-types';

import BIACombinedCarouselView from '../../../views/BIACombinedCarousel.view';
import BuyItAgainDrawerView from '../../BuyItAgainDrawer.view';

export const getisShowStackedRecs = (isBIACombinedCarouselEnabled, isOutfitsOnBagEnabled) =>
  isBIACombinedCarouselEnabled || isOutfitsOnBagEnabled;

export const getFormattedProducts = (product, products) => {
  if (!product) return null;
  return {
    dimension66: `bia-bag|items-${products?.length}`,
    ...product,
  };
};

export const getFetchOutfits = (isOutfitsOnBagEnabled, excludedIds) => {
  return isOutfitsOnBagEnabled && excludedIds;
};

const BuyItAgainBagPageWrapper = (props) => {
  const {
    isBIACombinedCarouselEnabled,
    className,
    isShopAllDrawerOpen,
    openShopAllDrawer,
    onQuickViewOpenClick,
    labels,
    renderRecommendations,
    getBIABagPageProducts,
    biaDynamicData,
    getBIADrawerproducts,
    getMoreBiaDrawerProducts,
    initialProductLoaded,
    totalProductsCount,
    biaDrawerProducts,
    biaProducts,
    isLoggedIn,
    orderItemsCount,
    isLoadingBIAPageProducts,
    biaInitialApiActualProductCount,
    getBIAConfigData,
    trackAnalyticsPageViewWeb,
    trackAnalyticsClickWeb,
    isRecommendationCarouselRedesignEnabled,
    spcBag,
    fetchBagOutfitProductsActn,
    renderBagPageOutfits,
    excludedIds,
    isOutfitsOnBagEnabled,
    outfitCountOnBag,
    showOutfitsOnBag,
    currencySymbol,
    page,
  } = props;
  const [productArr, setProductArr] = useState([]);
  const [products, setProducts] = useState([]);
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  useEffect(() => {
    if (getFetchOutfits(isOutfitsOnBagEnabled, excludedIds))
      fetchBagOutfitProductsActn({
        categoryId: excludedIds,
        count: outfitCountOnBag,
        isRelatedOutfit: true,
      });
  }, [excludedIds, isOutfitsOnBagEnabled]);

  useEffect(() => {
    const biaBagPageCategoryCode = getBIAConfigData?.categoryCode;
    if (biaProducts.length) {
      const cachedProducts =
        biaProducts && Array.isArray(biaProducts)
          ? biaProducts?.find(
              (buyItAgainProduct) => buyItAgainProduct.categoryCode === biaBagPageCategoryCode
            )
          : {};
      setProducts(cachedProducts?.buyItAgainProducts || []);
    }
  }, [biaProducts]);
  useEffect(() => {
    if (isLoggedIn) {
      getBIABagPageProducts();
    }
  }, [isLoggedIn]);

  useEffect(() => {
    if (!products?.length) return;
    const prodArr = products?.map((buyItAgainProduct) =>
      getFormattedProducts(buyItAgainProduct, products)
    );
    trackAnalyticsClickWeb({
      metric62: '1',
      customEvents: ['event62', 'event66'],
      eVar66: `bia-bag|items-${products?.length}`,
    });
    setProductArr(prodArr);
  }, [products]);

  return isMounted ? (
    <>
      {getisShowStackedRecs(isBIACombinedCarouselEnabled, isOutfitsOnBagEnabled) && (
        <BIACombinedCarouselView
          className={className}
          isShopAllDrawerOpen={isShopAllDrawerOpen}
          openShopAllDrawer={openShopAllDrawer}
          onQuickViewOpenClick={onQuickViewOpenClick}
          labels={labels}
          renderRecommendations={renderRecommendations}
          isLoggedIn={isLoggedIn}
          getBIABagPageProducts={getBIABagPageProducts}
          biaDynamicData={biaDynamicData}
          getBIADrawerproducts={getBIADrawerproducts}
          getMoreBiaDrawerProducts={getMoreBiaDrawerProducts}
          totalProductsCount={totalProductsCount}
          initialProductLoaded={initialProductLoaded}
          biaDrawerProducts={biaDrawerProducts}
          biaProducts={productArr}
          orderItemsCount={orderItemsCount}
          isLoadingBIAPageProducts={isLoadingBIAPageProducts}
          biaInitialApiActualProductCount={biaInitialApiActualProductCount}
          getBIAConfigData={getBIAConfigData}
          trackAnalyticsPageView={trackAnalyticsPageViewWeb}
          trackAnalyticsClick={trackAnalyticsClickWeb}
          isRecommendationCarouselRedesignEnabled={isRecommendationCarouselRedesignEnabled}
          spcBag={spcBag}
          renderBagPageOutfits={renderBagPageOutfits}
          isBIACombinedCarouselEnabled={isBIACombinedCarouselEnabled}
          isOutfitsOnBagEnabled={isOutfitsOnBagEnabled}
          showOutfitsOnBag={showOutfitsOnBag}
          currencySymbol={currencySymbol}
          page={page}
        />
      )}
      <BuyItAgainDrawerView
        labels={labels}
        isShopAllDrawerOpen={isShopAllDrawerOpen}
        openShopAllDrawer={openShopAllDrawer}
        onQuickViewOpenClick={onQuickViewOpenClick}
        totalProductsCount={totalProductsCount}
        initialProductLoaded={initialProductLoaded}
        trackAnalyticsPageView={trackAnalyticsPageViewWeb}
        trackAnalyticsClick={trackAnalyticsClickWeb}
        {...props}
      />
    </>
  ) : null;
};

BuyItAgainBagPageWrapper.propTypes = {
  className: PropTypes.string,
  isShopAllDrawerOpen: PropTypes.bool,
  openShopAllDrawer: PropTypes.func,
  onQuickViewOpenClick: PropTypes.func,
  labels: PropTypes.shape({}),
  getBIADrawerproducts: PropTypes.func,
  totalProductsCount: PropTypes.number,
  initialProductLoaded: PropTypes.number,
  getMoreBiaDrawerProducts: PropTypes.func,
  biaDrawerProducts: PropTypes.shape([]),
  isLoadingBIAPageProducts: PropTypes.bool,
  isBIACombinedCarouselEnabled: PropTypes.bool,
  renderRecommendations: PropTypes.func,
  getBIABagPageProducts: PropTypes.func,
  biaProducts: PropTypes.shape([]),
  isLoggedIn: PropTypes.bool,
  orderItemsCount: PropTypes.number,
  trackAnalyticsClickWeb: PropTypes.func,
  trackAnalyticsPageViewWeb: PropTypes.func,
  User: PropTypes.shape({}),
  APIConfig: PropTypes.shape({}),
  session: PropTypes.shape({}),
};

BuyItAgainBagPageWrapper.defaultProps = {
  className: 'clas',
  isShopAllDrawerOpen: false,
  openShopAllDrawer: () => {},
  onQuickViewOpenClick: () => {},
  labels: {},
  getMoreBiaDrawerProducts: () => {},
  getBIADrawerproducts: () => {},
  totalProductsCount: 2,
  initialProductLoaded: 3,
  biaDrawerProducts: [],
  isLoadingBIAPageProducts: false,
  isBIACombinedCarouselEnabled: false,
  renderRecommendations: () => {},
  getBIABagPageProducts: () => {},
  biaProducts: [],
  isLoggedIn: false,
  orderItemsCount: 10,
  trackAnalyticsClickWeb: () => {},
  trackAnalyticsPageViewWeb: () => {},
  User: {},
  APIConfig: {},
  session: {},
};

export default withRouter(BuyItAgainBagPageWrapper);
